import { FC, useState } from 'react';
import { List, ListItemIcon } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  IconWrapper,
  Item,
  StyledListItem,
  StyledListItemText,
  StyledSubListItem,
  StyledCollapse,
  Stick,
} from 'containers/AppContainer/SideBar/style';
import HomeIcon from 'components/SahamIcons/HomeIcon';
import FeeNoteIcon from 'components/SahamIcons/FeeNoteIcon';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';
import { history } from 'store';
import { PAGES } from 'routes';
import NewSinisterIcon from 'components/SahamIcons/NewSinistersIcon';
import ArrowRightIcon from 'components/SahamIcons/ArrowRightIcon';
import ArrowDownIcon from 'components/SahamIcons/ArrowDownIcon';

const selectedItem = (paths: string[]) => {
  return paths.some(path => path === history.location.pathname);
};

export interface PreOpeningManagerMenuProps {
  intl: IntlShape;
  isManager?: boolean;
  pushToAndReset: Function;
  isMenuOpen: boolean;
}

const PreOpeningManagerMenu: FC<PreOpeningManagerMenuProps> = (
  props,
): JSX.Element => {
  const [subListOpen, setSubListOpen] = useState(false);

  const toggleSubListOpen = () => {
    setSubListOpen(!subListOpen);
  };
  const { pushToAndReset, isMenuOpen } = props;

  return (
    <List>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.PREOPEN_MANAGER_HOME])}
          onClick={pushToAndReset(PAGES.PREOPEN_MANAGER_HOME)}
        >
          <ListItemIcon>
            <HomeIcon isActivated />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.sideBarHomeTitle, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
      <Item>
        <StyledListItem
          data-testid="sub-menu"
          open={isMenuOpen}
          button
          selected={selectedItem([
            PAGES.PREOPEN_MANAGER_VALIDATED_CLAIMS,
            PAGES.PREOPEN_MANAGER_PENDING_CLAIMS,
            PAGES.PREOPEN_MANAGER_REJECTED_CLAIMS,
          ])}
          onClick={toggleSubListOpen}
        >
          <ListItemIcon>
            <NewSinisterIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.newSinistersTitle, props)}
              </span>
            </StyledListItemText>
          )}
          {isMenuOpen ? (
            subListOpen ? (
              <IconWrapper>
                <ArrowDownIcon />
              </IconWrapper>
            ) : (
              <IconWrapper>
                <ArrowRightIcon />
              </IconWrapper>
            )
          ) : null}
        </StyledListItem>
      </Item>
      <StyledCollapse
        in={subListOpen && isMenuOpen}
        timeout="auto"
        unmountOnExit
      >
        <Stick />
        <List component="div" disablePadding>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.PREOPEN_MANAGER_VALIDATED_CLAIMS])}
              onClick={pushToAndReset(PAGES.PREOPEN_MANAGER_VALIDATED_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarOpenedTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.PREOPEN_MANAGER_PENDING_CLAIMS])}
              onClick={pushToAndReset(PAGES.PREOPEN_MANAGER_PENDING_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarPendingTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.PREOPEN_MANAGER_REJECTED_CLAIMS])}
              onClick={pushToAndReset(PAGES.PREOPEN_MANAGER_REJECTED_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarRejectedTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
        </List>
      </StyledCollapse>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.PREOPEN_MANAGER_FEE_NOTE])}
          onClick={pushToAndReset(PAGES.PREOPEN_MANAGER_FEE_NOTE)}
        >
          <ListItemIcon>
            <FeeNoteIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <>
              <StyledListItemText open={isMenuOpen}>
                <span className="menuItemText">
                  {translate(messages.sideBarFeeNote, props)}
                </span>
              </StyledListItemText>
            </>
          )}
        </StyledListItem>
      </Item>
    </List>
  );
};

export default injectIntl(PreOpeningManagerMenu);
